import React from "react";
import { useTranslation } from "react-i18next";
import { SharedEventList } from "./sharedEventList";

/**
 * HSE/KS Near Misses List - Near misses (HMS)
 */
export const HseKsNearMissesList = () => {
  const { t } = useTranslation();

  return (
    <SharedEventList
      activeTab="near-misses"
      title="Nestenulykker"
      subtitle="Oversikt over nestenulykker (HMS - ISO 45001)"
      newButtonLabel={t("Ny nestenulykke")}
      newButtonPath="/dashboard/hse-ks/events/new?type=near-miss"
      emptyMessage={t("Ingen nestenulykker funnet")}
      searchPlaceholder={t("Søk i nestenulykker...")}
      defaultFilters={{
        event_type: "near_miss",
      }}
    />
  );
};

